module.exports = __webpack_public_path__ + "img/telegram.23a021a0.png";